module.exports = __webpack_public_path__ + "img/noPhoto.79fecc1d.jpg";